import { render, staticRenderFns } from "./invtImport.vue?vue&type=template&id=44581bd2&scoped=true"
import script from "./invtImport.vue?vue&type=script&lang=js"
export * from "./invtImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44581bd2",
  null
  
)

export default component.exports